import { Injectable } from '@angular/core';
import { MetadataResource } from './metadata.resource';

@Injectable({
  providedIn: 'root',
})
export class EmploymentPositionService extends MetadataResource {
  constructor() {
    super('employment-position');
  }
}
